import * as React from 'react'
import { Chip } from '@mui/material'
import { ItemWithSideInfo } from 'src/timeline'
import { CardActionsMenu, Header } from 'src/designSystem'
import { FeedOverdueQuestionnaireItemFragment } from '../feedQueries.generated'
import { FeedItemCard } from '../FeedComponents'
import { useMentionLesson } from '../mentionLesson'
import { useMentionResponse } from '../mentionResponse'

const HEALTH_QUESTIONNAIRE_TITLE = 'Health questionnaire'
const HEALTH_QUESTIONNAIRE_CATEGORY = 'HEALTH_QUESTIONNAIRE'

type Props = {
  overdueQuestionnaire: FeedOverdueQuestionnaireItemFragment
}

export default function OverdueQuestionnaireItem({ overdueQuestionnaire }: Props) {
  const { setLesson } = useMentionLesson()
  const { removeResponse } = useMentionResponse()

  const header = (
    <Header
      title={HEALTH_QUESTIONNAIRE_TITLE}
      iconCategory={HEALTH_QUESTIONNAIRE_CATEGORY}
      summary={`Module ${overdueQuestionnaire.moduleNumber}`}
      action={<Chip label="Overdue" color="error" size="small" sx={{ fontWeight: 600 }} />}
    />
  )

  const actions = (
    <CardActionsMenu
      actions={[
        {
          label: 'Comment in chat',
          onClick: () => {
            removeResponse()
            setLesson({
              lessonID: overdueQuestionnaire.questionnaireLessonID,
              title: HEALTH_QUESTIONNAIRE_TITLE,
              category: HEALTH_QUESTIONNAIRE_CATEGORY,
            })
          },
        },
      ]}
    />
  )

  return (
    <ItemWithSideInfo alignItem="left" actions={actions} stickToTop>
      <FeedItemCard variant="outlined" header={header} isCompleted={false} isExpandable={false} />
    </ItemWithSideInfo>
  )
}
